import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { keyEmptyCheck } from 'aurora-utils/utils';
import classNames from 'classnames';
import { ADGMImage } from 'aurora-components';

function ApplicationJourney(props) {
  const { classes, applicationJourney } = props;

  return (
    <>
      <Box className={classNames([classes.applicationJourney, classes.sectionColumn])}>
        <Box className={classes.title}>
          <Typography component='h2'>{keyEmptyCheck('application_journey')}</Typography>
        </Box>
        <Box className={classNames([classes.steps, classes.sectionRow])}>
          <Box className={classes.initialStep}>
            <Typography component='p'>{keyEmptyCheck('initiate_your_application')}</Typography>
          </Box>
          {applicationJourney?.map(item => {
            const finalStep = item?.step === 'final';
            return (
              <>
                <Box className={classNames([finalStep ? classes.finalStep : classes.middleStep])}>
                  <Box>
                    <Box className={classes.round}>{finalStep ? <ADGMImage name='check.svg' /> : item?.step}</Box>
                  </Box>
                  <Box>
                    <Typography component='p'>{keyEmptyCheck(item?.title)}</Typography>
                  </Box>
                </Box>
              </>
            );
          })}
        </Box>
      </Box>
    </>
  );
}

ApplicationJourney.propTypes = {
  classes: PropTypes.object.isRequired,
  applicationJourney: PropTypes.array.isRequired,
};

export default ApplicationJourney;
